<template>
	<div>
		<b-modal
			ref="corral-selector-modal"
			@hidden="$emit('close')"
			:title="`${from.name}`"
			no-close-on-backdrop
			cancel-title="Cancelar"
			size="md"
		>
			<ValidationObserver ref="form">
				<b-row>
					<b-col class="input-select-corral" cols="12">
						<b-form-group id="input-group-1" label="Elegir corral de destino:" label-for="input-1">
							<ValidationProvider rules="required" v-slot="{ errors }">
								<v-select
									v-model="corral_id"
									:options="corrals"
									:clearable="false"
									label="full_name"
									:reduce="(option) => option.id"
									:class="{ 'border-danger rounded': errors[0] }"
								>
									<template v-slot:option="option">
										<div class="d-flex justify-content-between align-items-center">
											<span>{{ option.full_name }}</span>
										</div>
									</template>
								</v-select>
								<span v-if="errors[0]" class="text-danger">{{ errors[0] }}</span>
							</ValidationProvider>
						</b-form-group>
					</b-col>
				</b-row>
			</ValidationObserver>
			<template #modal-footer>
				<b-button @click="$emit('hidden')" v-if="!loading" variant="outline-primary">Cancelar</b-button>
				<b-button variant="secondary" disabled v-else>
					<b-spinner small />
					Cargando...
				</b-button>
				<b-button variant="outline-primary" @click="save" v-if="!loading">Guardar</b-button>
				<b-button variant="outline-primary" disabled v-else>
					<b-spinner small />
					Cargando...
				</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
import modalMixin from "@/mixins/modal.js"
import corralService from "@/services/encaste/corral.service"

export default {
	name: "MoveAllChicksToCorralModal",
	components: {},
	mixins: [modalMixin],
	props: {
		from: {
			type: Object,
			default: () => ({
				id: null,
				name: "",
			}),
		},
		qty: {
			required: true,
		},
	},
	async mounted() {
		this.isPreloading()
		await this.getActiveCorrals()
		this.toggleModal("corral-selector-modal")
		this.isPreloading(false)
	},
	computed: {},
	data() {
		return {
			corral_id: null,
			loading: false,
			corrals: [],
		}
	},
	methods: {
		async getActiveCorrals() {
			try {
				const { data } = await corralService.getActiveCorrals()
				this.corrals = data.map((corral) => ({
					...corral,
					full_name: `${corral.code} - ${corral.alias}`,
				}))
				this.corrals = this.corrals.filter((corral) => corral.id != this.from.id)
			} catch (error) {
				console.log(error)
			}
		},
		async save() {
			try {
				if (!(await this.$refs.form.validate())) {
					this.showToast("danger", "top-right", "Error", "AlertCircleIcon", "Complete los campos")
					return
				}
				const to = {
					id: this.corral_id,
					name: this.corrals.find((corral) => corral.id == this.corral_id).full_name,
				}
				const { isConfirmed } = await this.showConfirmSwal({
					title: "¿Estás seguro de cambiar corrales?",
					html: `
							<div>
							<p><strong>Cantidad:</strong> ${this.qty}</p>
							<p><strong>Origen:</strong> ${this.from.name}</p>
							<p><strong>Destino:</strong> ${to.name}</p>
							</div>
						`,
				})
				if (!isConfirmed) return
				this.isPreloading()
				await corralService.moveAllChicksToCorral(this.from.id, to.id)
				this.showToast(
					"success",
					"top-right",
					"Corrales",
					"CheckIcon",
					"El cambio de corrales se realizo correctamente"
				)
				this.$emit("ok")
			} catch (error) {
				this.showToast("danger", "top-right", "Error", "AlertCircleIcon", "Error al cambiar de corral")
			} finally {
				this.isPreloading(false)
			}
		},
	},
}
</script>

<style lang="scss" scoped></style>
